export const togglePasswordVisibility = () => {
    const passwordToggles = document.querySelectorAll('[vdx-password-toggle]');
    if (passwordToggles.length === 0) return;
    
    passwordToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            // Find the closest form and then find either an existing password input with our attribute
            // or a standard password input that we can mark
            const form = toggle.closest('form');
            if (!form) return;
            
            let passwordInput = form.querySelector('input[vdx-password-input]');
            
            if (!passwordInput) {
                passwordInput = form.querySelector('input[type="password"]');
                if (passwordInput) {
                    passwordInput.setAttribute('vdx-password-input', '');
                } else {
                    return;
                }
            }
            
            // Toggle between password and text type
            passwordInput.type = passwordInput.type === "password" ? "text" : "password";
            
            // Toggle vdx--active class on the toggle element and its children
            toggle.classList.toggle('vdx--active');
            toggle.querySelectorAll('*').forEach(child => child.classList.toggle('vdx--active'));
        });
    });
}
